import { makeStyles } from "@fluentui/react-components";
import { LatLngExpression } from "leaflet";
import React, { useMemo } from "react";
import { FeatureGroup, Tooltip } from "react-leaflet";
import { ISTATUS } from "../../../../models/common/CommonModels";
import { IRSCInfo } from "../../../../utils/maps/MapConstants";
import { splitIntoThreeWithGaps } from "../../../../utils/maps/MapHelperFunctions";
import RSCMarkerTooltip from "./RSCMarkerTooltip";
import RunwaySegment from "./RunwaySegment";

export interface RSCMarkerProps {
  airportCode: string;
  runwayName: string;
  start: LatLngExpression;
  end: LatLngExpression;
  rscInfo: IRSCInfo;
  gapMeters?: number;
  status: [ISTATUS, ISTATUS, ISTATUS];
  weight?: number;
  haloWidth?: number;
}

const RSCMarker: React.FC<RSCMarkerProps> = ({
  airportCode,
  runwayName,
  start,
  end,
  rscInfo,
  gapMeters = 6,
  status,
  weight = 10,
  haloWidth = 16,
}) => {
  const styles = useStyles();

  const segments = useMemo(
    () => splitIntoThreeWithGaps(start, end, gapMeters),
    [start, end, gapMeters]
  );

  if (!start || !end) {
    console.warn("RSCMarker: Missing start or end coordinates");
    return null;
  }

  return (
    <FeatureGroup>
      <Tooltip direction="bottom" opacity={1} className={styles.tooltip} sticky>
        <RSCMarkerTooltip
          airportCode={airportCode}
          runwayName={runwayName}
          current={rscInfo.current}
          prior={rscInfo.prior}
        />
      </Tooltip>

      {segments.map((line, idx) => (
        <RunwaySegment
          key={`seg-${JSON.stringify(line[0])}`}
          idx={idx}
          line={line}
          status={status[idx]}
          haloWidth={haloWidth}
          weight={weight}
        />
      ))}
    </FeatureGroup>
  );
};

export default RSCMarker;

const useStyles = makeStyles({
  tooltip: {
    zIndex: 10000,
    width: "max-content",
    whiteSpace: "normal",
    overflowWrap: "anywhere",
  },
});
